import { ApiaApi, makeApiaUrl } from '@apia/api';
import { EventEmitter } from '@apia/util';
import { usePanelIdentity } from '../common';
import { TPanelId } from '../types';

class ConfigEmitter extends EventEmitter<{
  refresh: { panelId: TPanelId };
}> {}

export const configEmitter = new ConfigEmitter();

/**
 * Esta función devuelve una función que al ser llamada abre el modal de
 * configuración del panel actual. Este modal permite al usuario modificar
 * parámetros y una vez confirmado, el resultado de la operación deberá ser
 * tomado por una función aún inexistente.
 *
 * Esta función se deberá encargar de almacenar los parámetros recibidos desde
 * el server para el panel actual, así como hacerle llegar al panel
 * correspondiente los datos emitidos por su contraparte en el servidor, a fin
 * de que actualice su vista.
 *
 * Admite un callback que será llamado cada vez que se confirme el modal de
 * configuración. Este callback se expone a fin de permitir la ejecución de
 * acciones previas al refresh que es lanzado en forma automática cuando
 */
export function usePanelConfig() {
  const { panelId } = usePanelIdentity();

  return function config() {
    void ApiaApi.post(
      makeApiaUrl({
        action: 'panelEdit',
        pnlId: panelId,
      }),
      { handleLoad: true },
    );
  };
}
